import { render, staticRenderFns } from "./tproduct.vue?vue&type=template&id=455bcc3c&"
import script from "./tproduct.vue?vue&type=script&lang=js&"
export * from "./tproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports